import { reportsDataSelector } from "./reportsDataSelector";
import { ReportsData } from "../utils/types/types";
import { RootState } from "../../store";

export const reportsDataPropertyByKeySelector =
  <T extends keyof ReportsData>(key: T) =>
  (state: RootState): ReportsData[T] => {
    return reportsDataSelector(state)[key];
  };
